module.exports = __webpack_public_path__ + "static/media/apparel 6.657dd536.jpg";